// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"437":"ed06756c","604":"a5b48a9b"}[chunkId] + ".chunk.js";
};